import React from "react";

const EditorialCtaFlow = ({
  children,
  action,
  actionClassName = "",
  className = "",
}) => (
  <div
    className={`editorial-cta-flow ${className}`.trim()}
  >
    <div className="editorial-cta-flow__copy">{children}</div>{" "}
    {action && (
      <span
        className={`editorial-cta-flow__action ${actionClassName}`.trim()}
      >
        {action}
      </span>
    )}
  </div>
);

export default EditorialCtaFlow;
